import { RootState } from '../types';
import {
  ITicketsParams,
  ITicket,
  ITicketFilterOptions,
  ITicketNote,
} from '../../services/tickets/types';
import { storeResources } from '../resources';

export const TicketsSelector = (state: RootState): ITicket[] => state.tickets.tickets;

export const TicketNotesSelector = (state: RootState): ITicketNote[] => state.tickets.notes;
export const TicketsCountSelector = (state: RootState): number => state.tickets.totalCount;

export const TicketsParamsSelector = (state: RootState): ITicketsParams => state.tickets.params;
export const TicketSearchParamSelector = (state: RootState): string =>
  state[storeResources.TICKETS].params.search;

export const TicketsLoadingStateSelector = (state: RootState): boolean =>
  state.tickets.ticketsLoading;

export const TicketSelector = (state: RootState): ITicket | null =>
  state[storeResources.TICKETS].ticket;

export const TicketFilterOptionsSelector = (state: RootState): ITicketFilterOptions =>
  state[storeResources.TICKETS].ticketsFiltersOptions;
